export function preloadImage(src) {
  if (!src) return;
  try {
    let image = new Image();
    image.src = src;
  } catch (e) {
    console.error(e);
  }
}

export function preloadImages(sources) {
  for (const source of sources) {
    preloadImage(source);
  }
}
